export const PlateNumberColor = {
    List: [
        {value: "01", label: "VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR_BLUE"},
        {value: "02", label: "VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR_YELLOW"},
        {value: "03", label: "VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR_WHITE"},
        {value: "04", label: "VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR_BLACK"},
        {value: "05", label: "VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR_GREEN"},
        {value: "99", label: "VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR_OTHER"},
    ],
    Map: new Map<string, string>([
        ['01', 'VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR_BLUE'],
        ['02', 'VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR_YELLOW'],
        ['03', 'VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR_WHITE'],
        ['04', 'VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR_BLACK'],
        ['05', 'VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR_GREEN'],
        ['99', 'VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR_OTHER'],
    ]),
    Enum: {
        Blue: '01',
        Yellow: "02",
        White: '03',
        Black: '04',
        Green: '05',
        Other: '99'
    }
};